import React,{Component} from "react";
import _ from "lodash";



export default class BooleanAlert extends Component
{

  constructor(props)
  {
    super(props);
    this.state={visible:false}

  }

open(title,body,yes,no,yesText,noText)
{
  this.yes=yes;
  this.no=no;

  this.setState({title,body,visible:true});

}



onClose()
{
  this.setState({visible:false});
}


  render()
  {
        if(this.state.visible==false)
        {
          return <div></div>;
        }

return  (<div   className="modal show">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <button type="button" onClick={()=>{
          this.onClose();
        }} className="close" data-dismiss="modal">&times;</button>
        <h4 className="modal-title">{this.state.title}</h4>
      </div>
      <div className="modal-body">
                {this.state.body}

      </div>
      <div className="modal-footer">

      <button onClick={()=>{

            if(this.yes)
            {
              this.yes();
              this.onClose();
            }

      }} type="button" className="btn btn-danger" data-dismiss="modal">Yes</button>
        <button onClick={()=>{

              if(this.no)
              {
                this.no();

              }
                this.onClose();

        }} type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>);
  }



}
